import React from "react";

import { List } from "../../../components/Data/List";

import { AddressRow } from "./AddressRow";

export interface AddressListProps {
    /** The wallet addresses to render. Empty → nothing rendered. */
    addresses: string[];
    /** Detach an address from the list. */
    onRemove: (address: string) => void;
}

/**
 * AddressList — the flat, borderless list of access-control wallet addresses.
 * A Domain Component that composes the shared `List` GC with one `AddressRow`
 * per address.
 */
export function AddressList({
    addresses,
    onRemove
}: AddressListProps): React.ReactElement | null {
    if (addresses.length === 0) return null;
    return (
        <List className="mt-2 flex flex-col gap-1">
            {addresses.map((addr) => (
                <AddressRow
                    key={addr}
                    address={addr}
                    onRemove={() => onRemove(addr)}
                />
            ))}
        </List>
    );
}
